export default {
    PUBLICATION: 'publication'
}
